<!-- 面试预约记录 -->
<template>
  <div class="interview-record">
    <!-- 有圆的加 interview-record-circle-->
    <div class="interview-record-item interview-record-circle">
      <h1>预约记录-进行中</h1>
      <ul v-if="unfinishList.length > 0">
        <li v-for="(item, index) in unfinishList"
            :key="index">
          <div class="interview-record-item-con">
            <img :src="item.mentorAvaurl"
                 alt="头像">
            <span>{{item.mentorType}}导师 - {{item.mentorName}}</span>
            <!-- green red orange -->
            <div class="interview-record-item-title"
                 :class="item.statu|todoStatusColorMap"
                 @click="handleLink(item)">
              {{ item.statu|todoStatusTitleMap }}
            </div>
          </div>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
    <!--  -->
    <div class="interview-record-item">
      <h1>预约记录-已完成</h1>
      <ul v-if="finishList.length>0">
        <li v-for="(item, index) in finishList"
            :key="index">
          <div class="interview-record-item-con">
            <img :src="item.mentorAvaurl"
                 alt="头像">
            <span>{{item.mentorType}}导师 - {{item.mentorName}}</span>
            <div class="interview-record-item-title"
                 :class="{green: item.statu !== 'SYSTEM_RECALL' && item.statu !== 'RECALL'}">
              {{ item.statu|filterStatus }}
            </div>
          </div>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
  </div>
</template>
<script>
// components
import ZlrEmpty from '_c/empty/empty'
// api
import { getAppInterviewUnfinishList, getAppInterviewFinishList } from '@/api/appointment'
export default {
  name: 'project-interview-record',
  components: {
    ZlrEmpty
  },
  data () {
    return {
      programId: this.$route.params.id,
      unfinishList: [],
      finishList: []
    }
  },
  computed: {},
  mounted () {
    this.getUnfinishList()
    this.getFinishList()
  },
  methods: {
    // 获取未完成的
    getUnfinishList () {
      getAppInterviewUnfinishList({
        projectId: this.programId
      }).then(res => {
        this.unfinishList = res.data.model
      })
    },
    //  获取已完成
    getFinishList () {
      getAppInterviewFinishList({
        projectId: this.programId
      }).then(res => {
        this.finishList = res.data.model
        // console.log(res)
      })
    },
    // 跳转页面
    handleLink ({ id }) {
      this.$router.push({
        name: 'project-interview-zoom',
        query: {
          id
        }
      })
    }
  },
  filters: {
    // 状态
    filterStatus (item) {
      let title = ''
      let statu = item.statu
      if (statu === 'SYSTEM_RECALL') {
        title = '已自动关闭'
      } else if (statu === 'RECALL') {
        title = 'CD已撤回预约'
      } else {
        title = `耗时${item.timeSpent || 0}mins`
      }
      return title
    }
  }
}
</script>
<style lang='less' scoped>
</style>
